import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warning from Leaflet maps
const RESIZE_OBSERVER_ERRS = [
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
];
window.addEventListener("error", (e) => {
  if (RESIZE_OBSERVER_ERRS.some((msg) => (e?.message || "").includes(msg))) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (RESIZE_OBSERVER_ERRS.some((msg) => (e?.reason?.message || "").includes(msg))) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (production only — CRA dev serves no SW)
if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
